import {
  FormControl,
  Select,
  ListSubheader,
  MenuItem,
  FormHelperText,
  BaseSelectProps,
  styled,
  Typography,
} from '@mui/material';
import React, { forwardRef } from 'react';

const Placeholder = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.fontSizes.regular,
}));
import { FieldError } from 'react-hook-form';

interface Props
  extends Omit<BaseSelectProps, 'error' | 'fullWidth' | 'placeholder'> {
  accountOptions: Array<{ label: string; value?: string | null }>;
  error?: FieldError;
  placeholder?: string;
}

const AccountSelector: React.FC<Props> = forwardRef(
  ({ accountOptions, error, placeholder, ...rest }, ref) => {
    return (
      <FormControl fullWidth error={!!error}>
        <Select
          {...rest}
          fullWidth
          ref={ref}
          displayEmpty={!!placeholder}
          renderValue={
            placeholder
              ? (value) =>
                  value ? (
                    accountOptions.find((o) => o.value === value)?.label
                  ) : (
                    <Placeholder>{placeholder}</Placeholder>
                  )
              : undefined
          }
        >
          {accountOptions.map((option) =>
            !option.value ? (
              <ListSubheader key={option.label}>{option.label}</ListSubheader>
            ) : (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ),
          )}
        </Select>
        {!!error && (
          <FormHelperText error={!!error}>{error?.message}</FormHelperText>
        )}
      </FormControl>
    );
  },
);

export default AccountSelector;
